import {
    Component, ElementRef, EventEmitter, HostListener,
    Input,
    OnInit, Output, TemplateRef,
    ViewChild
} from '@angular/core';
import {
    CsDropDownItemTemplatesComponent
} from '@app/shared/cs-components/cs-drop-down/cs-drop-down-item-templates/cs-drop-down-item-templates.component';
import {ICsDropDown} from '@app/shared/cs-components/cs-components.interface';
import {
    CsDropDownTogglerTemplatesComponent
} from '@app/shared/cs-components/cs-drop-down/cs-drop-down-toggler-templates/cs-drop-down-toggler-templates.component';
import {
    ICsItemElementClickArg, ICsPickerClickArg
} from '@app/shared/cs-components/cs-drop-down/cs-drop-down-item-templates/cs-drop-down-item.interface';
import {BsDatepickerDirective, BsDaterangepickerDirective, BsDropdownDirective} from 'ngx-bootstrap';
import {
    ICsDdGroupItem,
    ICsDdItem
} from '@app/shared/cs-components/cs-drop-down/cs-drop-down.interface';
import {CsDropDownService} from '@app/shared/cs-components/cs-drop-down/cs-drop-down.service';
import {TranslateService} from '@ngx-translate/core';
import {TCsPicker} from '@app/shared/cs-components/cs-components.types';
import * as moment from 'moment';
import {CsFaIcons} from '@app/shared/cs-components/cs-images.';

@Component({
    selector: 'app-cs-drop-down',
    templateUrl: './cs-drop-down.component.html',
    styleUrls: ['cs-drop-down.component.scss']
})
export class CsDropDownComponent implements OnInit {
    @ViewChild('togglerTemplates') togglerTemplates: CsDropDownTogglerTemplatesComponent;
    @ViewChild('itemTemplates') itemTemplates: CsDropDownItemTemplatesComponent;

    @Input() ddConfig: ICsDropDown;

    @Output() ddItemClick = new EventEmitter<ICsDdItem>();
    @Output() ddItemElementClick = new EventEmitter<ICsItemElementClickArg>();
    @Output() pickerClick = new EventEmitter<ICsPickerClickArg>();
    @Output() private thisRef = new EventEmitter<this>();

    togglersHolder: {[key: string]: TemplateRef<any>};
    itemsHolder: {[key: string]: TemplateRef<any>};
    noDataFoundMsg: 'No.Record.Found';
    ddSearchText = '';
    ISODateFormat = 'YYYY-MM-DD';
    _ddInstance: BsDropdownDirective;
    _dPInstance: BsDatepickerDirective | BsDaterangepickerDirective;

    constructor(
        private _hostRef: ElementRef,
        private _csDdService: CsDropDownService,
        private _translate: TranslateService
    ) {
    }

    ngOnInit() {
        this._csDdService.registerDdTemplates(this.togglerTemplates, this.itemTemplates)
            .subscribe(res => {
                this.togglersHolder = res.togglersHolder;
                this.itemsHolder = res.itemsHolder;
                this.setInitialConfig();
            });
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event): void {
        if (!this._hostRef.nativeElement.contains(event.target)) {
            this.closeDdMenu();
        }
    }

    setInitialConfig() {
        if (this.ddConfig.ddMenuConfig.isGroupItem) {
            this.ddConfig.ddMenuConfig.groupItems.forEach(group => {
                group.items.forEach(item => {
                    this._csDdService.setItemConfig(this.ddConfig, item, group);
                });
            });
        } else {
            this.ddConfig.ddMenuConfig.items.forEach(item => {
                this._csDdService.setItemConfig(this.ddConfig, item);
            });
        }

        this.ddConfig.ddMenuConfig.totalItemsCount = this.filteredItems('ALL').length;
        this.ddConfig.ddMenuConfig.selectedItemsCount = this.filteredItems('SELECTED').length;
    }

    onDdShown(ddInstance) {
        this._ddInstance = ddInstance;
        this.thisRef.emit(this);
    }

    onDdHidden() {
        this.ddSearchText = '';
        this.filterOrResetDdItems();
        this._ddInstance = null;
        this.thisRef.emit(null);
    }

    onDpShown(dpInstance: BsDatepickerDirective | BsDaterangepickerDirective) {
        this._dPInstance = dpInstance;
    }

    closeDdMenu() {
        if (this._ddInstance) {
            if (this._dPInstance) {
                this._dPInstance.hide();
                this._dPInstance = null;
            }
            this._ddInstance.hide();
        }
    }

    closeDdMenuOnElementClick(data) {
        if (!data.item.isMultiChoiceItem
            || (data.itemElement && data.itemElement.isDdMenuHide)
            || (data.elType === 'TEXT' && data.item.templateData.isDdMenuHide)) {
            this.closeDdMenu();
        }
    }

    toggleFavIcon(data: ICsItemElementClickArg) {
        if (data.elType === 'ICON' && data.itemElement.isFavouriteIndicator) {
            data.item.isFavourite = !data.item.isFavourite;
            data.itemElement.src = data.item.isFavourite ? CsFaIcons.starSolid : CsFaIcons.starRegular;
            // data.item.isFavEnabled = data.itemElement.isFavourite;
        }
    }

    onDdItemClick(item: ICsDdItem) {
        if (!item.isPicker) {
            this.resetSelectedDdItems(item);
            this.updateTogglerWhileItemSelection(item);
            if (!item.isMultiChoiceItem || item.isDdMenuHide) {
                this.closeDdMenu();
            }
            this.ddItemClick.emit(item);
        }
    }

    onDdItemElementClick(data: ICsItemElementClickArg) {
        this.resetSelectedDdItems(data.item);
        this.updateTogglerWhileItemSelection(data.item);
        this.toggleFavIcon(data);
        this.closeDdMenuOnElementClick(data);
        this.ddItemElementClick.emit(data);
    }

    onPickerClick(type: TCsPicker, item: ICsDdItem, val) {
        this.resetSelectedDdItems(item);
        this.updateTogglerWhileItemSelection(item, val);
        if (!item.isMultiChoiceItem || item.isDdMenuHide) {
            this.closeDdMenu();
        }
        this.pickerClick.emit({item, type, val});
    }

    resetSelectedDdItems(selectedItem: ICsDdItem) {
        selectedItem.isSelected = selectedItem.isMultiChoiceItem ? !selectedItem.isSelected : true;

        if (!selectedItem.isMultiChoiceItem) {
            if (this.ddConfig.ddMenuConfig.isGroupItem) {
                this.ddConfig.ddMenuConfig.groupItems.find(group => {
                    if (group.id === selectedItem.ddGroupId) {
                        this.resetPreviousSelectedItems(group.items, selectedItem);
                        return true;
                    }
                });
            } else {
                this.resetPreviousSelectedItems(this.ddConfig.ddMenuConfig.items, selectedItem);
            }
        }

        // this.updateTogglerWhileItemSelection(selectedItem);
    }

    resetPreviousSelectedItems(itemsList: ICsDdItem[], selectedItem: ICsDdItem) {
        itemsList.forEach(item => {
            if (item.id !== selectedItem.id) {
                item.isSelected = false;
            }
        });
    }

    updateTogglerWhileItemSelection(selectedItem: ICsDdItem, pickerVal?) {
        if (selectedItem.isMultiChoiceItem) {
            this.ddConfig.ddMenuConfig.selectedItemsCount = this.filteredItems('SELECTED').length;
        } else {
            if (selectedItem.isPicker) {
                switch (selectedItem.pickerType) {
                    case 'DATE':
                        const selectedVal = moment(pickerVal).format('DD-MM-YYYY');
                        this.ddConfig.ddTogglerConfig.templateData['text'] = `${selectedItem.templateData['text']} (${selectedVal})`;
                        break;
                    case 'DATE_RANGE':
                        const fromDt = moment(pickerVal[0]).format('DD-MM-YYYY');
                        const toDt = moment(pickerVal[1]).format('DD-MM-YYYY');
                        this.ddConfig.ddTogglerConfig.templateData['text'] = `${selectedItem.templateData['text']} (${fromDt} - ${toDt})`;
                        break;
                }
            } else {
                this.ddConfig.ddTogglerConfig.templateData['text'] = selectedItem.templateData['text'];
                this.ddConfig.ddTogglerConfig.templateData['background'] = selectedItem.templateData['background'];
            }
        }
    }

    filterOrResetDdItems(searchText = '') {
        this.ddSearchText = searchText;

        if (this.ddConfig.ddMenuConfig.isSearchBar) {
            if (this.ddConfig.ddMenuConfig.isGroupItem) {
                this.ddConfig.ddMenuConfig.groupItems.forEach(group => {
                    group.items
                        .forEach(item => {
                            const itemText = (this.ddConfig.ddMenuConfig['templateType'] === 'CUSTOM' && !item.templateData['text']) ? item.templateData['customData'][item.templateData['customTextLabelKey']] : item.templateData['text'];
                            item.isHide = !(this._translate.instant(itemText)).toLowerCase().includes(searchText.toLowerCase());
                        });
                });
            } else {
                this.ddConfig.ddMenuConfig.items
                    .forEach(item => {
                        const itemText = (this.ddConfig.ddMenuConfig['templateType'] === 'CUSTOM' && !item.templateData['text']) ? item.templateData['customData'][item.templateData['customTextLabelKey']] : item.templateData['text'];
                        item.isHide = !(this._translate.instant(itemText)).toLowerCase().includes(searchText.toLowerCase());
                    });
            }
        }
    }

    // Helper functions :

    getDdMenuGridColumnSetup(columns: number) {
        return `repeat(${columns || 1}, 1fr)`;
    }

    filteredItems(filterBy: 'SELECTED' | 'ENABLED' | 'ALL'): ICsDdItem[] {
        return this._csDdService.getItemsBy(this.ddConfig, filterBy);
    }
}
